import { Component, ViewChild, Inject } from '@angular/core';
import { DashboardTileCountViewModel } from '@modules/api/dashboard-tile-count-view-model.generated';
import { AgGridComponent } from '@modules/common/components/ag-grid/ag-grid.component';
import { AgGridColumn } from '@modules/common/models/ag-grid-column';
import { ExtendedDashboardTileViewModel } from '@modules/dashboard/models/extended-dashboard-tile-view-model';
import { DashboardDetailGridModalArgs } from '@modules/dashboard/models/dashboard-detail-grid-modal-args';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dashboard-detail-grid-modal',
    templateUrl: './dashboard-detail-grid-modal.component.html',
    styleUrls: ['./dashboard-detail-grid-modal.component.scss'],
})
export class DashboardDetailGridModalComponent {
    public readonly tile: ExtendedDashboardTileViewModel;
    public readonly item?: DashboardTileCountViewModel;
    public readonly totalItems: number;

    public readonly tileData: { [key: string]: any }[];

    public readonly headers: AgGridColumn[];

    @ViewChild('grid')
    private _gridDomElement?: AgGridComponent;

    constructor(@Inject(MAT_DIALOG_DATA) args: DashboardDetailGridModalArgs) { 
        this.tile = args.dashboardTile;
        this.item = args.dashboardTileItem;
        this.headers = args.headers.map<AgGridColumn>(header => ({
            dataType: header.dataType,
            fieldName: header.fieldName
        }));
        this.tileData = args.data;
        this.totalItems = this.item?.itemCount || this.tile!.summary!.totalRecords;
    }

    public onButtonExport(): void {
        if (this._gridDomElement && this.tile) {
            this._gridDomElement.exportData(this.tile.dashboardTileName);
        }
    }
}
